import { type IconComponentBaseProps } from '@/components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type TextSnippetFillProps = IconComponentBaseProps;

export const TextSnippetFill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: TextSnippetFillProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="translate(3.5 3.5)">
        <path
          d="M1.80775 17C1.31058 17 0.885 16.823 0.531 16.469C0.177 16.115 0 15.6894 0 15.1923V1.80775C0 1.31058 0.177 0.885 0.531 0.531C0.885 0.177 1.31058 0 1.80775 0H11.3943L17 5.60575V15.1923C17 15.6894 16.823 16.115 16.469 16.469C16.115 16.823 15.6894 17 15.1923 17H1.80775ZM3.75 13H13.25V11.5H3.75V13ZM3.75 9.25H13.25V7.75H3.75V9.25ZM3.75 5.5H10.1152V4H3.75V5.5Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
